export default {
  data: () => ({
    regex: /[^0-9.]/g,
  }),
  computed: {
    materialList() {
      return this.$store.getters.getRebarList;
    },
    constructionId() {
      return this.$store.state.Const.constructionId.constructionId ?? "";
    },
    constructionName() {
      return this.$store.getters.getConstructionId ?? "";
    },
    roleType() {
      return this.$store.getters.getUserList.roleType;
    },
    userState() {
      return this.$store.state.User.userState;
    },
  },
  methods: {
    dateCheck(val) {
      if (val) return this.$moment(val).format("YY.MM.DD");
      else return "-";
    },

    mathRound(val) {
      return Math.round(val * 1000) / 1000;
    },

    sum(list) {
      if (!list) return 0;
      let sum = 0;
      for (let i = 0; i < list.length; i++) {
        sum += Number(list[i] ? list[i] : 0);
      }
      return this.mathRound(sum);
    },

    listMaker(valueList) {
      let list = [];
      for (let i = 0; i < valueList.length; i++) {
        list[i] = [];
        for (let j = 0; j < valueList[i].length; j++) {
          list[i][j] = valueList[i][j];
        }
      }
      return list;
    },

    memoClick(value, state) {
      this.$bus.$emit("memoOn", value, state);
    },

    memoListClick(value, state) {
      this.$bus.$emit("memoListOn", value, state);
    },

    regexForData(val) {
      if (val)
        return val.replace(this.regex, "") == ""
          ? 0
          : this.mathRound(val.replace(this.regex, ""));
      else return 0;
    },

    totalSumLists(val) {
      let returnValue = { orderSumList: [], invoiceSumList: [], totalSum: [] };
      if (val.length == 0) return;
      for (let i = 0; i < val[0].rebarList.length; i++) {
        returnValue.orderSumList[i] = 0;
        returnValue.invoiceSumList[i] = 0;
      }
      for (let i = 0; i < val.length; i++) {
        for (let j = 0; j < val[0].rebarList.length; j++) {
          val[i].invoiceId
            ? (returnValue.invoiceSumList[j] += this.mathRound(
                Number(val[i].rebarList ? val[i].rebarList[j] : 0)
              ))
            : (returnValue.orderSumList[j] += this.mathRound(
                Number(val[i].rebarList[j])
              ));
        }
      }

      for (let j = 0; j < val[0].rebarList.length; j++) {
        returnValue.totalSum[j] = this.mathRound(
          Number(returnValue.orderSumList[j] - returnValue.invoiceSumList[j])
        );
      }
      return returnValue;
    },

    listSum(val, value) {
      let returnValue = [];

      for (let i = 0; i < val.length; i++) {
        for (let j = 0; j < val[i][value].length; j++) {
          if (i == 0) returnValue[j] = 0;
          returnValue[j] += this.mathRound(Number(val[i][value][j]));
        }
      }
      return returnValue;
    },
  },
};
